<div class="test-actions" uiCustomization [elementName]="'worklist-test-actions'">
  <div *ngIf="showActions">

    <span *ngIf="hasPatientContext && testCount>0" (click)="togglePanel($event)"
          class="test-actions-dropdown Auto_Test_Actions" #toggle>
      {{ 'ALL_ITEMS' | translate}} <span>({{testCount}})</span>
      <i class="icon__expand"></i>
    </span>

    <section class="test-action-panel"
             *ngIf="hasPatientContext && testCount>0"
             (clickOutside)="togglePanel($event,false)"
             (window:resize)="positionPanel($event,false)"
             [ngClass]="{'open':panelState}" #panel>
      <section class="test-actions-header">
        <h3 class="test-count">{{testCount}} {{'test'| stringTranslate}}{{testCount==1?'':'s'}}</h3>
      </section>
      <tr class="all-items-header">
        <td class="testType">
          TestType
        </td>
        <td class="testNumber">
          TestNumber
        </td>
        <td class="revision">
          Revision
        </td>
        <td class="date">
          Date
        </td>
        <td class="status">
          Status
        </td>
        <td class="mrn">
          MRN
        </td>
      </tr>
      <gen-test-list *ngIf="panelState"
                     [tests]="(patientTestsFromStore) || (patientTests$|async)"
                     [currentRevisionId]="currentRevision"
                     (testSelectEmit)="goToTest($event)"
      ></gen-test-list>

      <section class="test-actions-footer">
        <gen-add-test *ngIf="addTestAvailable && !previewMode" [newTestConfig]="testService?.testConfiguration?.newTestConfig"
        (closePanel)="panelState=!panelState"
        (popupTestCreation)="popupTestCreation($event)" ></gen-add-test>
      </section>
    </section>

    <section [style.display]="(testCount === -1 || testCount > 0) ? 'none' : 'block'">
      <gen-add-test test="'gen-add-test'" *ngIf="addTestAvailable && !previewMode && !(hasPatientContext && testCount>0)"
        [newTestConfig]="testService?.testConfiguration?.newTestConfig"
        (closePanel)="panelState=!panelState"
        (popupTestCreation)="popupTestCreation($event)">
      </gen-add-test>
    </section>
  </div>
</div>

<gen-dynamic-modal-loader [observableName]="'NEW_TEST_CHANNEL'"></gen-dynamic-modal-loader>
<gen-dynamic-modal-loader class="duplicate-warning-message" [observableName]="'ShowWarningChannel'"></gen-dynamic-modal-loader>
